import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { StudentBasicInfoService } from './student-basic-info-service'
import { FormValidator } from "../form.validator";
import * as registrationStrings from "../stringFiles/registration.json";
import parsePhoneNumberFromString from 'libphonenumber-js/max';
import { commonFunctionService } from '../utils/commonFunctions';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { BrandService } from '../brand/brand.service';

declare let $: any;
declare let moment_js: any;
declare let customToastr: any;
@Component({
  selector: 'app-student-basic-info',
  templateUrl: './student-basic-info.component.html',
  styleUrls: ['./student-basic-info.component.css'],
  providers: [StudentBasicInfoService, FormValidator]
})
export class StudentBasicInfoComponent implements OnInit {
  strings: any;
  @Input() studentName: string;
  @Input() visible: string;
  @Input() studentId: string;
  @Input() academicId: string;
  @Input() button_text: string;
  @Input() schoolCurrency: string;
  @Output() save_button_event: EventEmitter<any> = new EventEmitter();
  @Output() closePopup: EventEmitter<any> = new EventEmitter();
  @ViewChild('editStudentContactNumber', { static: false }) editStudentInputRef!: ElementRef;
  profileIsLoading: boolean;
  studentData: any = {};
  houseNameList = [];
  categoryList: any = [];
  classStandardsList: any = [];
  sectionList: any = [];
  initialClassId: number;
  initialClassStandardId: number;
  initialClassCategoryId: number;
  initialCategoryList: any = [];
  initialClassStandardsList: any = [];
  initialSectionList: any = [];
  blockClassChange: boolean;
  admittedClassYear: any;

  showClassChangeWarning: boolean = false;
  updateStudentClassChangeError: any = {};
  removeStudentProfilePicStatus = false;
  debounceTimer: any;
  invalidEditStudentMobileNumber: boolean = false;
  editSelectedStudentContact: string = "";
  isoCountryCode: string = ""
  isStudentMobileNumberChanged: boolean = false;
  casteCertificateFileType: string = ""
  speciallyAbledFileType: string = ""
  ewsCertificateFileType: string = ""
  singleGirlChildCertificateFileType: string = ""
  tcOrBirthCertificateFileType: string = ""
  aadharReferenceFileType: string = ""
  fileType: string | null = null;
  studentCountryCode: string;

  constructor(private studentBasicInfoService: StudentBasicInfoService, private formValidator: FormValidator, private commonFunction: commonFunctionService, private translate: TranslateService, private brandService: BrandService) {
    this.strings = registrationStrings
    this.studentCountryCode = this.brandService.brand.defaultCountryDialCode || '91';
  }

  ngOnInit() {
    this.getSchoolHouseListDetails();
    this.getStudentProfileDetails();
    this.isStudentMobileNumberChanged = false;
  } 

  getIntlTelInputGlobals(): any {
    return (window as any).intlTelInputGlobals;
  }
 

  handleKeyDown(event: KeyboardEvent) {
    this.commonFunction.handleKeyDown(event);
  }
  getSchoolHouseListDetails() {
    this.studentBasicInfoService.getSchoolHouseList(localStorage.getItem('usertoken')).subscribe(
      (data: any) => {
        if (data.status) {
          this.houseNameList = JSON.parse(JSON.stringify(data.list));
        }
        else {
          this.houseNameList = [];
        }
      },
      error => {
        console.error(error)
      }
    );
  }
  
  getStudentProfileDetails() {
    this.profileIsLoading = true;
    this.studentBasicInfoService.getStudentDetailsForEditForm(this.studentId, localStorage.getItem('usertoken')).subscribe(
      (data: any) => {
        this.profileIsLoading = false;
        this.studentData = JSON.parse(JSON.stringify(data.student));
        this.studentCountryCode = this.studentData.studentCountryCode || this.brandService.brand.defaultCountryDialCode || '91';
        this.editSelectedStudentContact = this.studentData.studentPhone
        const countryData = this.getIntlTelInputGlobals().getCountryData();
        const matchedCountry = countryData.find((country: any) => {
          return `${country.dialCode}` == this.studentCountryCode ;
        });
        const mobileNumberForStudent = $('#edit-student-number');
        mobileNumberForStudent.val("");
        mobileNumberForStudent.intlTelInput({
          initialCountry: matchedCountry.iso2,
          separateDialCode: false,
          autoPlaceholder: 'off',
          autoFormat: false,
          nationalMode: false,
          formatOnDisplay:false,
          allowDropdown: true,
          utilsScript:
            'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.4/js/utils.js'
        });

        mobileNumberForStudent.on('countrychange',()=>{
          mobileNumberForStudent.val('');
          const countryData = mobileNumberForStudent.intlTelInput(
            "getSelectedCountryData"
          );
          this.studentCountryCode = countryData.dialCode;
        })
        this.isoCountryCode = matchedCountry.iso2
        this.categoryList = data.categories;
        this.classStandardsList = data.classStandards;
        this.sectionList = data.sections;
        this.initialCategoryList = data.categories;
        this.initialClassStandardsList = data.classStandards;
        this.initialSectionList = data.sections;
        this.initialClassId = data.student.classId;
        this.initialClassStandardId = data.student.fkClassStandardsId;
        this.initialClassCategoryId = data.student.categoryId;
        this.admittedClassYear = this.studentData.admittedClass + ", " + this.studentData.admittedAcademic;

        if (this.studentData.casteCertificate) {
          this.casteCertificateFileType = this.commonFunction.getFileTypeFromUrl(this.studentData.casteCertificate);
        }
        if (this.studentData.aadharCopy) {
          this.aadharReferenceFileType = this.commonFunction.getFileTypeFromUrl(this.studentData.aadharCopy);
        }


        if (this.studentData.tcOrBirthCertificate) {
          this.tcOrBirthCertificateFileType = this.commonFunction.getFileTypeFromUrl(this.studentData.tcOrBirthCertificate);
        }

        if (this.studentData.ewsCertificate) {
          this.ewsCertificateFileType = this.commonFunction.getFileTypeFromUrl(this.studentData.ewsCertificate);
        }

        if (this.studentData.speciallyAbledCertificate) {
          this.speciallyAbledFileType = this.commonFunction.getFileTypeFromUrl(this.studentData.speciallyAbledCertificate);
        }

        if (this.studentData.singleGirlChildCertificate) {
          this.singleGirlChildCertificateFileType = this.commonFunction.getFileTypeFromUrl(this.studentData.singleGirlChildCertificate);
        }


        this.studentData.isMinority = this.studentData.isMinority == 1 ? true : false
        if (this.studentData.dateOfBirth) {
          this.studentData.dateOfBirth = this.formatDate(this.studentData.dateOfBirth);
        }
        if (this.studentData.dateOfAdmission) {
          this.studentData.dateOfAdmission = this.formatDate(this.studentData.dateOfAdmission);
        }
        this.studentData.tcOrBirthCertificateUploaded = data.student.tcOrBirthCertificateUploaded == "NO" ? 0 : 1;
      },
      error => {
        this.profileIsLoading = false;
        console.error(error)
      }
    );
  }


  triggerSelectProfilePic() {
    $("#selectProfilePic").trigger('click');
  }

  async validateSelectedFile(file, imageFor) {
    let self = this;
    let extension = file.name.split('.').pop().toLowerCase();
    let ExtListToUpload = ['jpeg', 'png', 'jpg', "pdf"];
    let isValidFileExt = $.inArray(extension, ExtListToUpload);
    if (isValidFileExt == -1) {
      const pleaseSelectAValidImageTypeOfJpegPngJpgPdfTranslation = await firstValueFrom(this.translate.get('pleaseSelectAValidImageTypeOfJpegPngJpgPdf')); 
      customToastr(pleaseSelectAValidImageTypeOfJpegPngJpgPdfTranslation, 'error');
      return false;
    }
    else {
      if (file.size > (1024 * 1024 * 20)) {
        const imageSizeShouldNotExceed20MbTranslation = await firstValueFrom(this.translate.get('imageSizeShouldNotExceed20Mb')); 
        customToastr(imageSizeShouldNotExceed20MbTranslation, 'error');
        return false;
      }
      else {
        let reader = new FileReader();
        reader.onload = function (e: any) {
          if (imageFor === "aadharReference") {
            self.studentData.aadharCopy = e.target.result;
          }
          else if (imageFor === "tcOrBirthCertificate") {
            self.studentData.tcOrBirthCertificate = e.target.result;
          }
          else if (imageFor === "casteCertificate") {
            self.studentData.casteCertificate = e.target.result;
          }
          else
            if (imageFor === "speciallyAbled") {
              self.studentData.speciallyAbledCertificate = e.target.result;
            }
            else if (imageFor === "ewsCertificate") {
              self.studentData.ewsCertificate = e.target.result;
            }
            else if (imageFor === "singleGirlChildCertificate") {
              self.studentData.singleGirlChildCertificate = e.target.result;
            }
            else self.studentData.studentImage = e.target.result;
        };
        reader.readAsDataURL(file);
        return true;
      }
    }
  }

  editStudentProfilePic(event) {
    if (event.target.files && event.target.files[0]) {
      let file = event.target.files[0];
      let isValidFile = this.validateSelectedFile(file, "profilePic");
      if (isValidFile) {
        this.profileIsLoading = true;
        this.studentBasicInfoService.updateStudentInfo(localStorage.getItem('usertoken'), this.studentId, file, "profilePic").subscribe(
          async (data: any) => {
            console.log("dsafdv,da",data)
            this.profileIsLoading = false;
            const studentProfileImageSuccessfullyUpdatedTranslation = await firstValueFrom(this.translate.get('studentProfileImageSuccessfullyUpdated')); 
            const failedToUpdateStudentAadharCopyPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToUpdateStudentAadharCopyPleaseTryAgain')); 
            if (data.processedImageUrl) {
              this.studentData.studentImage = data.processedImageUrl[0];
              customToastr(studentProfileImageSuccessfullyUpdatedTranslation, 'success');
            }
            else {
                 customToastr(failedToUpdateStudentAadharCopyPleaseTryAgainTranslation, 'error');
            }  
            },
          async error => {
            this.profileIsLoading = false;
            const failedToUpdateStudentAadharCopyPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToUpdateStudentAadharCopyPleaseTryAgain')); 
            customToastr(failedToUpdateStudentAadharCopyPleaseTryAgainTranslation, 'error');
          }
        );
      }
    }
  }

  async openEditStudentAadharCopyUpload() {
    if (this.studentData.aadharNumber && this.studentData.aadharNumber.trim() != "") {
      $("#edit-student-aadhar-copy-basic").trigger('click');
    }
    else {
      const pleaseEnterAadharNumberBeforeUploadingAadharPicTranslation = await firstValueFrom(this.translate.get('pleaseEnterAadharNumberBeforeUploadingAadharPic')); 
      customToastr(pleaseEnterAadharNumberBeforeUploadingAadharPicTranslation, 'error');
    }
  }

  startUploadingEditStudentAadharCopy(event) {
    if (event.target.files && event.target.files[0]) {
      let file = event.target.files[0];
      this.aadharReferenceFileType = file.type;
      let isValidFile = this.validateSelectedFile(file, "aadharReference");
      if (isValidFile) {
        this.profileIsLoading = true;
        this.studentBasicInfoService.updateStudentInfo(localStorage.getItem('usertoken'), this.studentId, file, "aadharReference").subscribe(
          async (data: any) => {
            this.profileIsLoading = false;
            if (data.processedImageUrl) {
              this.studentData.aadharCopy = data.processedImageUrl[0];
            }
            const studentAadharCopySuccessfullyUpdatedTranslation = await firstValueFrom(this.translate.get('studentAadharCopySuccessfullyUpdated')); 
            customToastr(studentAadharCopySuccessfullyUpdatedTranslation, 'success');
          },
          async error => {
            this.profileIsLoading = false;
            const failedToUpdateStudentAadharCopyPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToUpdateStudentAadharCopyPleaseTryAgain')); 
            customToastr(failedToUpdateStudentAadharCopyPleaseTryAgainTranslation, 'error');          }
        );
      }
    }
  }

  openEditStudentTcBirthCertUpload() {
    $("#edit-student-tc-birth-cert-basic").trigger('click');
  }

  startUploadingEditStudentTcBirthCert(event) {
    if (event.target.files && event.target.files[0]) {
      let file = event.target.files[0];
      this.tcOrBirthCertificateFileType = file.type;
      let isValidFile = this.validateSelectedFile(file, "tcOrBirthCertificate");
      if (isValidFile) {
        this.profileIsLoading = true;
        this.studentBasicInfoService.updateStudentInfo(localStorage.getItem('usertoken'), this.studentId, file, "tcOrBirthCertificate").subscribe(
          async (data: any) => {
            this.profileIsLoading = false;
            if (data.processedImageUrl) {
              this.studentData.tcOrBirthCertificate = data.processedImageUrl[0];
            }
            const studentTcBirthCertificateSuccessfullyUpdatedTranslation = await firstValueFrom(this.translate.get('studentTcBirthCertificateSuccessfullyUpdated')); 
            customToastr(studentTcBirthCertificateSuccessfullyUpdatedTranslation, 'success');
          },
          async error => {
            this.profileIsLoading = false;
            const failedToUpdateStudentTcBirthCertificatePleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToUpdateStudentTcBirthCertificatePleaseTryAgain')); 
            customToastr(failedToUpdateStudentTcBirthCertificatePleaseTryAgainTranslation, 'error');
          }
        );
      }
    }
  }

  close() {
    this.visible = 'none';
    this.closePopup.emit();
  }

  formatDate(date) {
    return date ? moment_js(date).format('DD/MM/YYYY') : '-';
  }

  onChangeEditStudentCategory() {
    this.profileIsLoading = true;
    this.studentBasicInfoService.getClassStandardsByCategory(this.studentData.categoryId, localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          this.profileIsLoading = false;
          this.classStandardsList = data;
          this.studentData.fkClassStandardsId = null;
          this.studentData.classId = null;
          this.sectionList = [];
        },
        async error => {
          this.profileIsLoading = false;
          const failedToFetchClassStandardsPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToFetchClassStandardsPleaseTryAgain')); 
          customToastr(failedToFetchClassStandardsPleaseTryAgainTranslation, 'error');          
          this.classStandardsList = [];
          this.studentData.fkClassStandardsId = null;
          this.studentData.classId = null;
          this.sectionList = [];
        }
      );
  }

  onChangeEditStudentClass() {
    this.profileIsLoading = true;
    this.studentBasicInfoService.getClassSectionsByClassIdFun(this.studentData.fkClassStandardsId, localStorage.getItem('usertoken'))
      .subscribe(
        (data: any) => {
          this.profileIsLoading = false;
          this.sectionList = data;
          this.studentData.classId = null;
        },
        async error => {
          this.profileIsLoading = false;
          const failedToFetchClassSectionsPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToFetchClassSectionsPleaseTryAgain')); 
          customToastr(failedToFetchClassSectionsPleaseTryAgainTranslation, 'error');
          this.studentData.classId = null;
          this.sectionList = [];
        }
      );
  }

  onChangeEditStudentSection() {
    if (this.studentData.classId !== this.initialClassId) {
      this.profileIsLoading = true;
      this.studentBasicInfoService.studentClassChangeValidation(this.studentData.classId, this.initialClassId, this.studentId, localStorage.getItem('usertoken'))
        .subscribe(
          (data: any) => {
            this.profileIsLoading = false;
            if (data.allowUpdate == "NO") {
              this.blockClassChange = true;
              this.showClassChangeWarning = true;
              this.updateStudentClassChangeError = data;
            }
          },
          async error => {
            this.profileIsLoading = false;
            this.blockClassChange = false;
            this.showClassChangeWarning = false;
            this.updateStudentClassChangeError = {};
            const unableToCompleteRequestedActionPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('unableToCompleteRequestedActionPleaseTryAgain')); 
            customToastr(unableToCompleteRequestedActionPleaseTryAgainTranslation, 'error');
          }
        );
    }
  }

  async popupOkAction() {
    
    if (this.editSelectedStudentContact) {
      this.editMobileNumberValidator(this.editStudentInputRef.nativeElement);
      if (this.invalidEditStudentMobileNumber) {
        const pleaseEnterValidStudentMobileNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidStudentMobileNumber')); 
        customToastr(pleaseEnterValidStudentMobileNumberTranslation, 'error');
        return;
      }
    }
    let studentDOB = $('body').find("#basic-edit-student-dob").val();
    let admissionDate = $('body').find("#new-edit-student-admissiondate").val();
    if (!studentDOB || studentDOB == '') {
      const pleaseSelectStudentDateOfBirthTranslation = await firstValueFrom(this.translate.get('pleaseSelectStudentDateOfBirth')); 
      customToastr(pleaseSelectStudentDateOfBirthTranslation, 'error');
      return;
    }
    if (!admissionDate || admissionDate == '') {
      const pleaseSelectDateOfAdmissionTranslation = await firstValueFrom(this.translate.get('pleaseSelectDateOfAdmission')); 
      customToastr(pleaseSelectDateOfAdmissionTranslation, 'error');
      return;
    }

    if (this.studentData.penNumber) {
      const penNumberLength = this.studentData.penNumber.length;
      if (penNumberLength < 11 || penNumberLength > 12) {
        const pleaseEnterAValidPenNumberWith11Or12DigitsTranslation = await firstValueFrom(this.translate.get('pleaseEnterAValidPenNumberWith11Or12Digits')); 
        customToastr(pleaseEnterAValidPenNumberWith11Or12DigitsTranslation, 'error');
        return ;
      }
    }

    if (this.studentData.pinCode && this.studentData.pinCode.length < 6) {
      const pleaseEnterValidPinCodeIsExactly6DigitsTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidPinCodeIsExactly6Digits')); 
      customToastr(pleaseEnterValidPinCodeIsExactly6DigitsTranslation, 'error');
      return ;
    }

    const StudentDOBIsValid = this.formValidator.valdateDOB(studentDOB);
    if (!StudentDOBIsValid) {
      studentDOB = studentDOB.split("/");
      studentDOB = `${studentDOB[2]}-${studentDOB[1]}-${studentDOB[0]}`;
      admissionDate = admissionDate.split("/");
      admissionDate = `${admissionDate[2]}-${admissionDate[1]}-${admissionDate[0]}`;
      let reqObj = {
        aadharNumber: this.studentData.aadharNumber,
        classId: this.studentData.classId,
        countryCode: this.studentData.countryCode,
        dateOfBirth: studentDOB,
        dateOfAdmission: admissionDate,
        gender: this.studentData.gender.toString(),
        houseName: this.studentData.houseName,
        parentName: this.studentData.parentName,
        registrationId: this.studentData.registrationId,
        rollNumber: this.studentData.rollNumber,
        schoolId: this.studentData.schoolId,
        studentEmail: this.studentData.studentEmail,
        studentId: this.studentData.studentId,
        studentName: this.studentData.studentName,
        studentCountryCode: this.studentCountryCode,
        studentPhone: this.editSelectedStudentContact,
        surname: this.studentData.surname,
        tcOrBirthCertificateUploaded: this.studentData.tcOrBirthCertificateUploaded == 1 ? "YES" : "NO",
        academicId: this.academicId,
        penNumber: this.studentData.penNumber,
        caste: this.studentData.cast,
        isMinority: this.studentData.isMinority,
        isSpeciallyAbled: this.studentData.isSpeciallyAbled,
        isEWSCategory: this.studentData.isEWSCategory,
        isSingleGirlChild: this.studentData.isSingleGirlChild,
      };
      const studentValidateName = this.formValidator.validateFieldName(this.studentData.studentName, "Student ");
      const parentValidateName = this.formValidator.validateFieldName(this.studentData.parentName, "Parent ");
      if (this.studentData.studentPhone) {
        const mobileNumberIsvalid = this.formValidator.validateMobileNumberForNewAdmission(this.strings.student, this.studentData.studentPhone);
        if (mobileNumberIsvalid) {
          customToastr(mobileNumberIsvalid, "error")
          return;
        }
      }
      if (this.studentData.aadharNumber) {
        const aadharNumberIsvalid = this.formValidator.validateAadharNumber(this.studentData.aadharNumber);
        if (aadharNumberIsvalid) {
          customToastr(aadharNumberIsvalid, "error")
          return;
        }
      }
      if (this.studentData.studentEmail) {
        const studentEmailIsvalid = this.formValidator.validateIsEmail(this.studentData.studentEmail);
        if (!studentEmailIsvalid) {
          const pleaseEnterValidEmailAddressTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidEmailAddress')); 
          customToastr(pleaseEnterValidEmailAddressTranslation, 'error');
          return;
        }
      }
      
      if (
        (reqObj.countryCode && reqObj.classId) &&
        (reqObj.gender === "0" || reqObj.gender === "1") &&
        (reqObj.tcOrBirthCertificateUploaded === "YES" || reqObj.tcOrBirthCertificateUploaded === "NO") &&
        !parentValidateName &&
        (reqObj.registrationId && reqObj.schoolId && reqObj.studentId) &&
        !studentValidateName &&
        ($.isNumeric(reqObj.rollNumber))
      ) {
        this.profileIsLoading = true;
        this.studentBasicInfoService.updateStudentDetails(reqObj, localStorage.getItem('usertoken'))
          .subscribe(
            async (data: any) => {
              this.profileIsLoading = false;
              if (data.status) {
                const studentDetailsSuccessfullyUpdatedTranslation = await firstValueFrom(this.translate.get('studentDetailsSuccessfullyUpdated')); 
                customToastr(studentDetailsSuccessfullyUpdatedTranslation, 'success');
                this.save_button_event.emit();
              }
              else if (data.message) {
                customToastr(data.message, 'error');
              }
            },
            async error => {
              this.profileIsLoading = false;
              const unableToCompleteStudentProfileUpdatePleaseTryAgainTranslation = await firstValueFrom(this.translate.get('unableToCompleteStudentProfileUpdatePleaseTryAgain')); 
              customToastr(unableToCompleteStudentProfileUpdatePleaseTryAgainTranslation, 'error');
            }
          );
      }
      else {

        if (studentValidateName) {
          customToastr(studentValidateName, 'error')
        } else if (parentValidateName) {
          customToastr(parentValidateName, 'error')
        } else {
          const pleaseFillAllMandatoryDetailsTranslation = await firstValueFrom(this.translate.get('pleaseFillAllMandatoryDetails')); customToastr(pleaseFillAllMandatoryDetailsTranslation, 'error');
        }
      }
    }
    else {
      customToastr(StudentDOBIsValid, 'error');
    }
  }

  closeFeesNotification() {
    this.showClassChangeWarning = false;

    this.categoryList = this.initialCategoryList;
    this.classStandardsList = this.initialClassStandardsList;
    this.sectionList = this.initialSectionList;

    this.studentData.classId = this.initialClassId;
    this.studentData.fkClassStandardsId = this.initialClassStandardId;
    this.studentData.categoryId = this.initialClassCategoryId;
  }

  removeStudentProfilePic() {
    this.removeStudentProfilePicStatus = true;
    this.studentBasicInfoService.removeStudentProfilePic(localStorage.getItem('usertoken'), this.studentId).subscribe(
      async (data: any) => {
        if (data.errorcode) {
          this.removeStudentProfilePicStatus = false;
          const failedToDeletedStudentImagePleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToDeletedStudentImagePleaseTryAgain')); 
          customToastr(failedToDeletedStudentImagePleaseTryAgainTranslation, 'error');
          $("#deletePopupClose").trigger("click");
        } else {
          this.removeStudentProfilePicStatus = false;
          this.studentData.studentImage = ""
          const studentProfileImageSuccessfullyDeletedTranslation = await firstValueFrom(this.translate.get('studentProfileImageSuccessfullyDeleted')); 
          customToastr(studentProfileImageSuccessfullyDeletedTranslation, 'success');
          $("#deletePopupClose").trigger("click");
        }
      },
      async error => {
        this.removeStudentProfilePicStatus = false;
        const failedToDeletedStudentImagePleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToDeletedStudentImagePleaseTryAgain')); 
        customToastr(failedToDeletedStudentImagePleaseTryAgainTranslation, 'error');
        $("#deletePopupClose").trigger("click");
      }
    );
  }

  handleDebounceEditStudentMobileNumber(value): void {
    this.isStudentMobileNumberChanged = true;
      this.editMobileNumberValidator(value);
      if (this.editSelectedStudentContact == "") {
        this.invalidEditStudentMobileNumber = false;
      }
  }

// function to check whether mobile number is valid or not
  editMobileNumberValidator(mobileNumberInput): void {
    const fullNumber = $(mobileNumberInput).intlTelInput('getNumber');
    const phoneNumber = parsePhoneNumberFromString(fullNumber);
    if (!phoneNumber) {
      this.invalidEditStudentMobileNumber = true;
      return;
    }
    const isValid = phoneNumber.isValid();
    this.invalidEditStudentMobileNumber = !(isValid);
  }

  //New file uploads  
  openEditStudentCasteCertUpload() {
    $("#edit-student-caste-cert-basic").trigger('click');
  }

  openEditStudentSpeciallyAbledCertUpload() {
    $("#edit-student-specially-abled-cert-basic").trigger('click');
  }

  openEditStudentEWSCertUpload() {
    $("#edit-student-EWS-cert-basic").trigger('click');
  }

  openEditStudentSingleGirlCertUpload() {
    $("#edit-student-single-girl-cert-basic").trigger('click');
  }

  onMinorityChange(event: any) {
    this.studentData.isMinority = event.target.checked === true ? 1 : 0
  }

  onIsSpeciallyAbledChange(event: any) {
    this.studentData.isSpeciallyAbled = event.target.checked === true ? 1 : 0
  }

  onIsEWSCategoryChange(event: any) {
    this.studentData.isEWSCategory = event.target.checked === true ? 1 : 0
  }

  onIsSingleGirlChildChange(event: any) {
    this.studentData.isSingleGirlChild = event.target.checked === true ? 1 : 0
  }

  startUploadingEditStudentCertificate(event: any, certificateType: string, certificateKey: string) {
    if (event.target.files && event.target.files[0]) {
      let file = event.target.files[0];
      if (certificateType === "casteCertificate") {
        this.casteCertificateFileType = file.type;
      } else if (certificateType === "speciallyAbled") {
        this.speciallyAbledFileType = file.type;
      } else if (certificateType === "ewsCertificate") {
        this.ewsCertificateFileType = file.type;
      } else if (certificateType === "singleGirlChildCertificate") {
        this.singleGirlChildCertificateFileType = file.type;
      }

      let isValidFile = this.validateSelectedFile(file, certificateType);
      if (isValidFile) {
        this.profileIsLoading = true;
        this.studentBasicInfoService.updateStudentInfo(localStorage.getItem('usertoken'), this.studentId, file, certificateType).subscribe(
          async (data: any) => {
            this.profileIsLoading = false;
            if (data.processedImageUrl) {
              this.studentData[certificateKey] = data.processedImageUrl[0];
            }
            const studentTranslation = await firstValueFrom(this.translate.get('student'));
            const certificateSuccessfullyUpdatedTranslation = await firstValueFrom(this.translate.get('certificateSuccessfullyUpdated'));
            customToastr(`${studentTranslation} ${certificateType.replace(/([A-Z])/g, ' $1')} ${certificateSuccessfullyUpdatedTranslation}`, 'success');
          },
          async error => {
            this.profileIsLoading = false;
            const failedToUpdateStudentTranslation = await firstValueFrom(this.translate.get('failedToUpdateStudent'));
            const pleaseTryAgainTranslation = await firstValueFrom(this.translate.get('pleaseTryAgain'));
            customToastr(`${failedToUpdateStudentTranslation} ${certificateType.replace(/([A-Z])/g, ' $1')}, ${pleaseTryAgainTranslation}`, 'error');
          }
        );
      }
    }
  }
  startUploadingEditStudentCasteCert(event: any) {
    this.startUploadingEditStudentCertificate(event, "casteCertificate", "casteCertificate");
  }

  startUploadingEditStudentSpeciallyAbledCert(event: any) {
    this.startUploadingEditStudentCertificate(event, "speciallyAbled", "speciallyAbledCertificate",);
  }

  startUploadingEditStudentEWSCert(event: any) {
    this.startUploadingEditStudentCertificate(event, "ewsCertificate", "ewsCertificate",);
  }

  startUploadingEditStudentSingleGirlChildCert(event: any) {
    this.startUploadingEditStudentCertificate(event, "singleGirlChildCertificate", "singleGirlChildCertificate");
  }

  onCasteChange() {
    this.studentData.isEWSCategory = (this.studentData.cast !== 'General') ? 0 : this.studentData.isEWSCategory;
  }

  onGenderChange() {
    this.studentData.isSingleGirlChild = (this.studentData.gender === 1) ? 0 : this.studentData.isSingleGirlChild;
  }
} 
